import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IMetamask {
	address: string;
}

const initialState: IMetamask = {
	address: "",
};

export const metamaskSlice = createSlice({
	name: "metamask",
	initialState,
	reducers: {
		updateAddress: (state, actions: PayloadAction<any>) => {
			state.address = actions.payload;
		},
	},
});

export const { updateAddress } = metamaskSlice.actions;

export default metamaskSlice.reducer;
